import { useTranslation } from 'react-i18next';
import { Moon, Sun, Search, Bell, Globe } from 'lucide-react';
import { useTheme } from '@/theme/useTheme';
import i18n from '@/i18n';
import { Button } from '@/components/ui/Button';

/** Top bar: global search (<60s document rule), theme + language toggles, alerts. */
export function Topbar() {
  const { t } = useTranslation();
  const { mode, toggle } = useTheme();

  const switchLang = () => i18n.changeLanguage(i18n.language === 'es' ? 'en' : 'es');

  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 px-4 py-3 lg:px-6">
      <div className="glass flex flex-1 items-center gap-3 rounded-2xl px-4 py-2.5">
        <Search className="h-4 w-4 text-muted-foreground" />
        <input
          type="search"
          placeholder={t('actions.search')}
          aria-label={t('actions.search')}
          className="w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground"
        />
        <kbd className="hidden rounded-md border border-border px-1.5 py-0.5 text-[10px] text-muted-foreground sm:block">
          ⌘K
        </kbd>
      </div>

      <Button variant="glass" size="sm" aria-label="Language" onClick={switchLang}>
        <Globe className="h-4 w-4" />
        <span className="uppercase">{i18n.language}</span>
      </Button>

      <Button variant="glass" size="sm" aria-label="Notifications" className="relative">
        <Bell className="h-4 w-4" />
        <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-gold" />
      </Button>

      <Button variant="glass" size="sm" aria-label="Toggle theme" onClick={toggle}>
        {mode === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>
    </header>
  );
}
